export enum SCREENS {
    Login = 1,
    ManageUser = 2,
    ManageBusiness = 3,
    RegisterUser = 4,
    ManageCampaign = 5,
    ManagePhone = 6,
    Recharge = 7,
    Products = 8,
    Dashboard = 9,
    Trans = 10,
    AdminRecharge = 12,
    UserProfile = 13,
    Mask = 14,
    ManageTemplates = 15 
}